export default "/50f517735fec46580f19aae3e56e9fe21614ea75/2cb37da391587709fd85749e116baa74.svg";